import { getLoginInfo } from "~/api/redeemCode";
import { isInAppBrower, getGoArtClientInfo, isInGoArtAppBrower, getClientInfo, getUserToken, compareVersion, getBrowser } from "~/utils/common";
import jwt_decode from "jwt-decode";

const isProd = process.env.APP_ENV === "production";
console.log('=======>isProd',isProd)

//神策埋点配置
export async function sensorsAuthScripts(sensorsUseCn = false) {
    const isInFotorApp = !!isInAppBrower();
    const isInGoArtApp = !!isInGoArtAppBrower();
    const { appVersion: fotorAppVersion } = getClientInfo();
    const { appVersion: goartAppVersion } = getGoArtClientInfo();
    const { isAndroid, isiOS } = getBrowser();
    let host = sensorsUseCn
        ? "https://datasink-sa.fotor.com.cn"
        : "https://datasink-sa.fotor.com";
    let sensors_server_url =
        isProd
            ? host + "/sa?project=fotorglobalproduct"
            : host + "/sa?project=fotorglobaldefault";
    //神策埋点
    (function (para) {
        let p = para.sdk_url,
            n = para.name,
            w = window as any,
            d = document,
            s = "script";
        let x = null as any,
            y = null as any;
        if (typeof w["sensorsDataAnalytic201505"] !== "undefined") {
            return false;
        }
        w["sensorsDataAnalytic201505"] = n;
        w[n] =
            w[n] ||
            function (a: any) {
                return function () {
                    (w[n]._q = w[n]._q || []).push([a, arguments]);
                };
            };
        var ifs = [
            "track",
            "quick",
            "register",
            "registerPage",
            "registerOnce",
            "trackSignup",
            "trackAbtest",
            "setProfile",
            "setOnceProfile",
            "appendProfile",
            "incrementProfile",
            "deleteProfile",
            "unsetProfile",
            "identify",
            "login",
            "logout",
            "trackLink",
            "clearAllRegister",
            "getAppStatus"
        ];
        for (var i = 0; i < ifs.length; i++) {
            w[n][ifs[i]] = w[n].call(null, ifs[i]);
        }
        if (!w[n]._t) {
            (x = d.createElement(s) as any), (y = d.getElementsByTagName(s)[0]);
            x.async = 1;
            x.src = p;
            x.setAttribute("charset", "UTF-8");
            w[n].para = para;
            y.parentNode.insertBefore(x, y);
        }
    })({
        show_log: !isProd,
        // show_log: false,
        sdk_url: "https://pub-static.fotor.com/static/web/lib/sensors/sensorsdata.min.js",
        name: "sensors",
        //配置打通 App 与 H5 的参数
        // app_js_bridge:true,
        app_js_bridge: {
            white_list: [
                "https://datasink-sa.fotor.com.cn/sa?project=fotorglobaldefault",
                "https://datasink-sa.fotor.com.cn/sa?project=fotorglobalproduct",
                "https://datasink-sa.fotor.com/sa?project=fotorglobaldefault",
                "https://datasink-sa.fotor.com/sa?project=fotorglobalproduct",
            ]
        },
        //数据接收地址
        server_url: sensors_server_url,
        heatmap: { scroll_notice_map: "not_collect" },
        source_type: { search: ["yandex.", "duckduckgo.com", "ecosia.org"] }
    });

    if (window.sensors) {
        //全埋点自定义字段在 registerPage 中添加
        window.sensors.registerPage({
            platform_type: "mobile-web",
            FotorInnerBrowser: isInFotorApp,
            GoArtInnerBrowser: isInGoArtApp,
        });

        /*
          Fotor 未打通 App 与 H5 的版本，需要网页自己设置 sensors.login 进行打通
          Android 7.3.22 之前
          iOS 10.3.20 之前
        */
        try {
            let needVersion = isiOS ? "10.3.20" : "7.3.22";
            if (isInFotorApp && fotorAppVersion && compareVersion(fotorAppVersion, needVersion) < 0) {
                await sensorsFotorLogin();
            }
        } catch (e) {
            console.log('sensorsFotorLogin 调用错误', e);
        }

        /*
          GoArt 未打通 App 与 H5 的版本，需要网页自己设置 sensors.login 进行打通
        */
        try {
            let needVersion = isiOS ? "3.3.3" : "3.3.3";
            console.log("goartAppVersion, needVersion", isInGoArtApp, goartAppVersion, needVersion)
            if (isInGoArtApp && compareVersion(goartAppVersion || "1.0.0", needVersion) < 0) {
                await sensorsGoArtLogin();
            }
        } catch (e) {
            console.log('sensorsGoArtLogin 调用错误', e);
        }

        window.sensors.quick("autoTrack");
    }

}

async function sensorsFotorLogin() {
    let token = getUserToken();
    if (token) {
        let { data: { data, code } } = await getLoginInfo(token);
        if (code === "000") {
            window.sensors.login(data.id);
        }
    }
}

async function sensorsGoArtLogin() {
    let token = getUserToken();
    if (token) {
        var decoded = jwt_decode(token) as any;
        if (decoded.uid) {
            console.log('H5端手动打通', decoded.uid)
            window.sensors.login(decoded.uid);
        }
    }
}

// 埋点的公共方法
async function _addSensorPv(info: { [key: string]: any }): Promise<void> {
    const { action, label } = info;

    // 等待神策对象加载完成
    while (!window.sensors) {
        await new Promise((resolve) => setTimeout(resolve, 200));
    }

    // 神策埋点的方法
    window.sensors.track(action, {
        ...label
    });
}

export function sensorsTrack(action: string, label: any) {
    _addSensorPv({
        action: action,
        label: label
    });
}